module.exports = __webpack_public_path__ + "img/round-96x96.6ac724fa.png";